import { render, staticRenderFns } from "./KeyboardCall.vue?vue&type=template&id=0b3a6290&scoped=true"
import script from "./KeyboardCall.vue?vue&type=script&lang=js"
export * from "./KeyboardCall.vue?vue&type=script&lang=js"
import style0 from "./KeyboardCall.vue?vue&type=style&index=0&id=0b3a6290&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a6290",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
